import "./secondaryMenu.css";
import { useState, useEffect, useRef } from "react";

const SecondaryMenu = ({ hoveredTab, onTabHover, onTabLeave }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [onHover, setOnHover] = useState(null);
  const menuRef = useRef();

  useEffect(() => {
    window.innerWidth <= 1024 ? setIsOpen(false) : setIsOpen(true);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        window.innerWidth <= 1024 &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleResize = () => {
    if (window.innerWidth <= 1024) {
      setIsOpen(false);
    }
    if (window.innerWidth > 1024) {
      setIsOpen(true);
    }
  };

  const toggleAdvHamburger = () => {
    setIsOpen(!isOpen);
  };

  const clickAndCloseAdvHamburgerMenu = () => {
    if (window.innerWidth <= 1024) {
      setIsOpen(false);
    }
  };

  const scrollToCard = (cardId, fallbackId) => {
    let element = null;
    let altElement = null;
    element = document.getElementById(cardId);
    if (!element) {
      altElement = document.getElementById(fallbackId);
      if (!altElement) return;
    }

    clickAndCloseAdvHamburgerMenu();

    const header = document.querySelector("header");
    const secondaryMenu = document.querySelector(".advanced-navbar");
    const hamburgerMenu = document.querySelector("#hamburger2");

    const headerHeight = header ? header.offsetHeight : 0;
    const secondaryMenuHeight = secondaryMenu ? secondaryMenu.offsetHeight : 0;
    const hamburgerMenuHeight = hamburgerMenu ? hamburgerMenu.offsetHeight : 0;

    const y =
      (element !== null
        ? element.getBoundingClientRect().top
        : altElement.getBoundingClientRect().top) +
      window.scrollY -
      headerHeight -
      secondaryMenuHeight -
      hamburgerMenuHeight -
      16;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <>
      <div className="secondary-menu-wrapper">
        <div
          id="hamburger2"
          onClick={toggleAdvHamburger}
          title="In page menu"
          aria-label="Click to expand the menu for cards"
        >
          <i className="fa-solid fa-bars" aria-hidden="true"></i> PAGE MENU
        </div>

        <div
          className="advanced-navbar"
          style={{
            display: isOpen ? "flex" : "none",
          }}
          ref={menuRef}
        >
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("notify", "showcase")}
            aria-label="Link to navigate to Showcase card"
            onMouseEnter={() => {
              onTabHover("showcase");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "showcase" && "var(--orange)" }}
          >
            Showcase
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("assess")}
            aria-label="Link to navigate to Assess Wildfire Risk card card"
            onMouseEnter={() => {
              onTabHover("assess");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "assess" && "var(--green)" }}
          >
            Assess
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("download")}
            aria-label="Link to navigate to Scorecard card"
            onMouseEnter={() => {
              onTabHover("download");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "download" && "var(--cornflower-blue)",
            }}
          >
            Scorecard
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("sponsor")}
            aria-label="Link to navigate to Sponsor card"
            onMouseEnter={() => {
              onTabHover("sponsor");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "sponsor" && "var(--green)" }}
          >
            Sponsor
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("preparation")}
            aria-label="Link to navigate to Pilot card"
            onMouseEnter={() => {
              onTabHover("preparation");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "preparation" && "var(--orange)" }}
          >
            Pilot
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("collab")}
            aria-label="Link to navigate to Collaborate with Us card"
            onMouseEnter={() => {
              onTabHover("collab");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "collab" && "var(--orange)" }}
          >
            Collaborate
          </div>

          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("subscribe")}
            aria-label="Link to navigate to Subscribe card"
            onMouseEnter={() => {
              onTabHover("subscribe");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "subscribe" && "var(--cornflower-blue)",
            }}
          >
            Subscribe
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("feedback")}
            aria-label="Link to navigate to Share Your Feedback card"
            onMouseEnter={() => {
              onTabHover("feedback");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "feedback" && "var(--green)" }}
          >
            Share
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("contact")}
            aria-label="Link to navigate to Support us card"
            onMouseEnter={() => {
              onTabHover("contact");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{ color: hoveredTab === "contact" && "var(--orange)" }}
          >
            Support
          </div>
          <div
            className="secondary-menu-link"
            onClick={() => scrollToCard("contribute")}
            aria-label="Link to navigate to Contribute card"
            onMouseEnter={() => {
              onTabHover("contribute");
            }}
            onMouseLeave={() => {
              onTabLeave();
            }}
            style={{
              color: hoveredTab === "contribute" && "var(--cornflower-blue)",
            }}
          >
            Contribute
          </div>
        </div>
      </div>
    </>
  );
};

export default SecondaryMenu;
